import React, { createContext, useContext, useState } from "react";
import { resolveCourseTimezone } from "./courseDateTime";
const Context = createContext(null);
export function CourseProvider({ children, timezone }) {
  const [courses, setCourses] = useState([]);
  const [draft, setDraft] = useState({ title: "", academicLevel: "", instructions: "", files: [] });
  const [conversations, setConversations] = useState({});
  const [composers, setComposers] = useState({});
  const updateCourse = (id, change) => setCourses(previous => previous.map(course => course.id === id ? { ...course, ...change } : course));
  return <Context.Provider value={{ timezone: resolveCourseTimezone(timezone), courses, setCourses, draft, setDraft, conversations, setConversations, composers, setComposers, updateCourse }}>{children}</Context.Provider>;
}
export function useCourses() {
  const value = useContext(Context);
  if (!value) throw new Error("CourseProvider is required");
  return value;
}
